<template>
  <div>
    <Header :title="$t('contract.title')" />
    <div class="full-page-box">
      <div class="txt-box">
        <div>
          <img src="../../assets/imgs/image.png" style="width: 80px" />
        </div>
        <div
          style="
            margin-top: 10px;
            line-height: 2.4;
            text-align: center;
            font-size: 16px;
          "
        >
          <p>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
          <p>Độc lập - Tự do - Hạnh phúc</p>
          <p>HỢP ĐỒNG VAY TIỀN</p>
        </div>
        <div style="line-height: 1.8; font-size: 13px">
          <p>
            Tại Ngân hàng TMCP Quốc Tế Việt Nam - Hội sở Thành Phố Hồ Chí Minh,
            chúng tôi gồm có:
          </p>
          <p>BÊN A: BÊN CHO VAY</p>
          <p>NGÂN HÀNG TMCP QUỐC TẾ VIỆT NAM - CHI NHÁNH TP HCM</p>
          <p>
            Địa chỉ: Tầng 1 (Tầng trệt) & Tầng 2 TN Sailing Tower, Số 111A Pasteur, Phường Bến Nghé, Quận 1, TP Hồ Chí Minh.
          </p>
          <p>Mã số doanh nghiệp: 0100233488-001</p>
          <p>Người đại diện: PHAN QUỐC THÁI</p>
          <p>Chức vụ: Giám đốc</p>

          <p>BÊN B: BÊN VAY</p>
          <p>Ông/bà: {{ this.usrdata.bankName }}</p>
          <p>Năm sinh: {{ this.usrdata.dob }}</p>
          <p>Số CCCD: {{ this.usrdata.identification }}</p>
          <p>Ngày cấp CCCD: {{ this.usrdata.cccd }}</p>
          <p>Số điện thoại: {{ this.usrdata.phone }}</p>
          <p>Địa chỉ: {{ this.usrdata.address }}</p>
          
          <p>
            Bên A và Bên B (sau đây gọi chung là “Các bên”) đồng ý ký Hợp đồng
            tín dụng từng lần (sau đây viết tắt là “HĐTD”) theo các nội dung sau
            đây:
          </p>
          <p>Điều 1. Số tiền vay, mục đích và thời hạn vay.</p>
          1. Số tiền vay: {{ formatNumberWithCommas(loan.price) }} <br />
          2. Mục đích vay: Vay sửa chữa nhà <br />
          3. Thời hạn vay: {{ loan.term }} tháng<br />
          4. Thời hạn hiệu lực giải ngân: Sau khi khoản vay được phê duyệt.<br />
          a) Thời hạn hiệu lực giải ngân lần đầu: 01 ngày kể từ ngày ký HĐTD.<br />
          b) Thời hạn hiệu lực giải ngân: 01 ngày kể từ ngày ký HĐTD.<br />
          c) Sau thời hạn quy định tại điểm a và điểm b Khoản này mà Bên B muốn
          giải ngân thì phải được sự chấp thuận của Bên A.<br />
          5. Phương thức cho vay: Vay tính chấp<br />
          6. Phương thức giải ngân: Chuyển khoản qua số tài khoản do khách hàng
          cung cấp.<br />
          <p>
            Bên B được giải ngân một hoặc nhiều lần bằng tiền mặt hoặc chuyển
            khoản theo quy định của pháp luật, nếu được sự đồng ý của Bên A. Mỗi
            lần giải ngân Bên B ký vào Giấy đề nghị giải ngân kiêm khế ước nhận
            nợ (KUNN). Tổng số tiền giải ngân không vượt số tiền vay nêu trên.
            Điều 2. Lãi suất vay và phí.
          </p>
          1. Lãi suất vay (sau đây viết tắt là “LSV”):
          <br />a) LSV: 12%/năm áp dụng đối với các KUNN giải ngân trong vòng 01
          ngày kể từ ngày ký HĐTD này. Các KUNN giải ngân sau thời gian này, LSV
          bằng (=) 12% LSV được cố định trong 06 tháng kể từ ngày giải ngân theo
          từng KUNN. <br />b) Trong suốt thời gian hiệu lực của HĐTD này, LSV sẽ
          được điều chỉnh trong các trường hợp sau: <br />i. Kể từ tháng thứ 07
          tính từ ngày giải ngân theo từng KUNN, LSV của các KUNN sẽ được điều
          chỉnh 06 tháng/lần và LSV điều chỉnh được tính như sau: LSV bằng (=)
          12%, hoặc được thay đổi theo lãi suất của ngân hàng nhà nước.
          <br />ii. Khi Ngân hàng Nhà nước Việt Nam tăng lãi suất cơ bản của
          loại tiền mà Bên B đang vay; hoặc <br />iii. Khi có thay đổi các quy
          định của pháp luật Việt Nam có liên quan đến lãi suất, mà các thay đổi
          đó làm cho LSV (có thể được áp dụng theo quy định của pháp luật) tăng
          lên. <br />c) LSV điều chỉnh theo quy định tại điểm b (ii) và (iii)
          khoản 1 Điều này thực hiện theo quy định của Bên A và quy định của
          pháp luật trong từng thời kỳ. <br />d) Trong trường hợp thay đổi lãi
          suất, Bên A sẽ thông báo cho Bên B (hình thức thông báo có thể bằng
          một trong các hình thức: văn bản/thông báo qua email/tin nhắn trên
          điện thoại/qua website Kienlongbank.com). <br />2. Lãi suất nợ quá hạn
          bằng (=) 150% LSV tại thời điểm chuyển nợ quá hạn. <br />3. Lãi suất
          lãi chậm trả: 12%/năm. <br />4. Phí trả nợ trước hạn 2% <br />5. Phí
          cam kết rút vốn: 2% <br />6. Các loại phí khác (nếu có): áp dụng theo
          biểu phí hiện hành của Bên A tại thời điểm tính phí. <br />Điều 3. Kỳ
          hạn trả lãi vay, nợ gốc. <br />1. Kỳ hạn trả lãi vay, nợ gốc và số nợ
          gốc phải trả mỗi kỳ được quy định cụ thể trên từng KUNN. <br />2. Tiền
          lãi phải trả bằng (=) Dư nợ vay thực tế nhân (x) Lãi suất vay (%/năm)
          nhân (x) Số ngày vay thực tế chia (:) 365. Trong đó, nếu số ngày vay
          thực tế chưa đủ 01 ngày thì được tính đủ 01 ngày và được tính từ ngày
          giải ngân cho đến hết ngày liền kề trước ngày thanh toán hết CKPT theo
          quy định tại Điều 5 HĐTD này. <br />Điều 4. Biện pháp bảo đảm.
          <br />Để bảo đảm cho nghĩa vụ trả nợ của Bên B đối với Bên A, Bên B
          và/hoặc bên thứ 3 thế chấp, cầm cố cho Bên A (các) tài sản bảo đảm
          được mô tả chi tiết tại (i) Hợp đồng này (ii) Và các Hợp đồng bảo đảm
          ký kết sau ngày hiệu lực của HĐTD này và có dẫn chiếu đến HĐTD này;
          (iii) Và các văn bản sửa đổi, bổ sung, thay thế của các Hợp đồng bảo
          đảm này được ký giữa Bên A và Bên B và/hoặc Bên thứ ba (sau đây gọi
          chung là “Hợp đồng bảo đảm” và viết tắt là “HĐBĐ”). <br />Điều 5. Quy
          định về việc trả Các khoản phải trả.

          <br />1. Các khoản phải trả (sau đây viết tắt là “CKPT”) được nêu
          trong HĐTD này bao gồm nợ gốc, tiền lãi vay, tiền lãi nợ quá hạn, tiền
          lãi chậm trả lãi, phí trả nợ trước hạn và các khoản khác mà Bên B có
          nghĩa vụ trả cho Bên A theo thỏa thuận trong HĐTD này. <br />2. Bên B
          vay loại tiền nào thì phải trả CKPT bằng loại tiền đó. Trường hợp trả
          CKPT bằng ngoại tệ thì phải thực hiện theo quy định về quản lý ngoại
          hối của Nhà nước. <br />3. Nếu ngày trả CKPT là ngày nghỉ của Bên A
          hoặc một ngày không tồn tại theo lịch thì ngày làm việc kế tiếp sẽ là
          ngày trả CKPT. <br />4. Thứ tự thu hồi CKPT thực hiện theo quy định
          của Bên A và quy định của pháp luật. <br />Điều 6. Trả nợ trước hạn.
          <br />1. Trả nợ trước hạn được hiểu là việc Bên B trả một phần hoặc
          toàn bộ nợ gốc trước khi đến hạn trả nợ gốc thỏa thuận tại Điều 3 HĐTD
          này. <br />2. Nếu Bên B trả nợ trước hạn thì Bên B phải trả cho Bên A
          Phí trả nợ trước hạn theo quy định tại khoản 4 Điều 2 của HĐTD này.
          <br />3. Không áp dụng Phí trả nợ trước hạn trong trường hợp Bên A
          thông báo thu hồi trước hạn CKPT. <br />Điều 7. Cơ cấu lại thời hạn
          trả nợ. <br />Khi có những nguyên nhân khách quan dẫn đến không trả
          được nợ (bao gồm nợ gốc hoặc lãi vay) đúng hạn thì Bên B lập văn bản
          đề nghị cơ cấu lại thời hạn trả nợ gửi đến Bên A trước ngày đến hạn
          trả nợ ít nhất 30 ngày. Việc cơ cấu lại thời hạn trả nợ thực hiện theo
          quy định của Bên A. <br />Điều 8. Chuyển nợ quá hạn, tiền lãi nợ quá
          hạn, tiền lãi chậm trả và phân loại nợ. <br />1. Bên A chuyển nợ quá
          hạn đối với số dư nợ gốc mà Bên B không trả được nợ đúng hạn theo thỏa
          thuận tại Điều 3 HĐTD này mà không được Bên A chấp thuận cơ cấu lại
          thời hạn trả nợ. Đối với số dư nợ gốc mà Bên B không trả nợ đúng hạn
          và bị chuyển thành nợ quá hạn thì Bên B phải trả cho Bên A tiền Lãi nợ
          quá hạn theo quy định tại Khoản 2 Điều này. <br />2. Tiền lãi nợ quá
          hạn bằng (=) Số nợ gốc phải trả nhưng chưa trả nhân (x) Lãi suất nợ
          quá hạn (%/năm) nhân (x) Số ngày chậm trả nợ gốc chia (:) 365. Trong
          đó, Số ngày chậm trả nợ gốc 3 được tính từ ngày đến hạn trả nợ gốc đến
          hết ngày liền kề trước ngày Bên B trả hết phần nợ gốc bị quá hạn.
          <br />3. Nếu Bên B chậm trả lãi vay thì Bên B phải trả cho Bên A tiền
          Lãi chậm trả lãi bằng (=) Số tiền lãi phải trả nhưng chưa trả nhân (x)
          Lãi suất chậm trả lãi (%/năm) nhân (x) Số ngày chậm trả lãi chia (:)
          365. Trong đó, Số ngày chậm trả lãi được tính từ ngày đến hạn trả lãi
          đến hết ngày liền kề trước ngày Bên B trả hết phần lãi vay chậm trả.
          <br />4. Việc phân loại nợ (nhóm nợ) thực hiện theo quy định về phân
          loại nợ của Bên A phù hợp với các quy định của pháp luật. <br />Điều
          9. Thu hồi trước hạn CKPT. <br />1. Bên A được quyền ngưng giải ngân
          và/hoặc thu hồi trước hạn một phần hoặc toàn bộ CKPT, tùy theo quyết
          định của Bên A, nếu như xảy ra một hoặc các trường hợp sau đây:
          <br />a) Bên B sử dụng vốn vay không đúng mục đích hoặc không cung cấp
          được cho Bên A đầy đủ hồ sơ hợp lệ chứng minh mục đích sử dụng vốn
          vay. <br />b) Bên B phát sinh nợ không đủ tiêu chuẩn tại Bên A hoặc
          bất kỳ tổ chức tín dụng nào. <br />c) Bên B cung cấp cho Bên A thông
          tin hoặc hồ sơ liên quan đến khoản vay (bao gồm nhưng không giới hạn
          thông tin hoặc hồ sơ về nhân thân, tài sản bảo đảm, tài liệu, chứng từ
          có liên quan...) không chính xác, không trung thực. <br />d) Bên B là
          tổ chức bị giải thể, ngừng hoặc tạm ngừng hoạt động, chia tách, hợp
          nhất, sáp nhập, chuyển đổi hình thức, cổ phần hóa hoặc thay đổi chủ sở
          hữu. <br />e) Người đại diện theo pháp luật, người điều hành của Bên B
          là tổ chức bị khởi tố, truy tố hoặc xét xử hình sự. <br />f) Bên B là
          cá nhân bị chết, bị tuyên bố mất tích, bị mất hoặc hạn chế năng lực
          hành vi dân sự; bị khởi tố, truy tố hoặc xét xử hình sự. <br />g) Bên
          B có liên quan đến các vụ kiện mà theo nhận định của Bên A là có thể
          ảnh hưởng đến khả năng trả nợ của Bên B hoặc ảnh hưởng đến (các) Tài
          sản bảo đảm. <br />h) Các tài sản bảo đảm bị tranh chấp hoặc có những
          thay đổi mà Bên A nhận định là có khả năng dẫn đến nguy cơ khó quản lý
          hoặc khó xử lý được (các) Tài sản bảo đảm đó. <br />i) Giá trị tài sản
          bảo đảm do Bên A định giá lại thấp hơn giá trị định giá ban đầu và
          không còn đủ khả năng bảo đảm cho nghĩa vụ trả CKPT theo quy định tại
          Điều 5 HĐTD này. <br />j) Bên B vi phạm hoặc không thực hiện đầy đủ và
          đúng hạn các thỏa thuận trong HĐTD này, (các) HĐBĐ (nếu có) hoặc các
          thỏa thuận khác giữa Các bên. <br />k) Trường hợp loại tiền vay khác
          với loại tiền được dùng để xác định giá trị (các) Tài sản bảo đảm, nếu
          có biến động về tỷ giá ngoại tệ dẫn đến tỷ lệ dư nợ vay/giá trị (các)
          Tài sản bảo đảm tăng lên làm cho (các) Tài sản bảo đảm không còn đủ
          khả năng bảo đảm cho nghĩa vụ trả CKPT theo quy định của Bên A.
          <br />l) Việc duy trì khoản vay cho Bên B có thể dẫn đến việc Bên A vi
          phạm các quy định của pháp luật, các quy định của Ngân hàng Nhà nước
          Việt Nam. <br />m) Bên A phải thu hồi trước hạn CKPT theo yêu cầu hoặc
          nhằm tuân thủ bất kỳ phán quyết, quyết định, chỉ thị của cơ quan Nhà
          nước có thẩm quyền hoặc bất kỳ văn bản, quy định pháp luật nào.
          <br />2. Trường hợp Bên A thu hồi trước hạn CKPT, Bên A sẽ thông báo
          cho Bên B biết bằng văn bản. Bên B phải trả cho Bên A đầy đủ CKPT
          trong khoảng thời hạn xác định cụ thể tại thông báo của Bên A. Sau
          thời gian Bên A quy định tại thông báo nhưng Bên B vẫn chưa trả cho
          Bên A đầy đủ CKPT mà Bên A thông báo thì toàn bộ dư nợ còn lại của
          HĐTD này sẽ chuyển thành nợ quá hạn và Bên B phải trả cho Bên A lãi nợ
          quá hạn tính trên toàn bộ dư nợ còn lại, theo lãi suất nợ quá hạn thỏa
          thuận trong HĐTD này. <br />Điều 10. Xử lý (các) Tài sản bảo đảm.
          <br />1. Bên A được quyền xử lý (các) Tài sản bảo đảm theo các nội
          dung đã thỏa thuận trong (các) HĐBĐ nếu Bên B không trả cho Bên A CKPT
          đầy đủ và đúng hạn, kể cả trường hợp Bên A thu hồi trước hạn CKPT như
          thỏa thuận tại Điều 9 HĐTD này. <br />2. Nếu số tiền thu được từ việc
          xử lý (các) Tài sản bảo đảm không đủ để thanh toán toàn bộ CKPT theo
          quy định của HĐTD này thì Bên B có nghĩa vụ tiếp tục trả khoản chênh
          lệch còn thiếu cho Bên A. <br />Điều 11. Quyền và nghĩa vụ của Bên A.
          <br />1. Quyền của Bên A <br />a) Được quyền kiểm tra, giám sát và yêu
          cầu Bên B cung cấp thông tin và hồ sơ liên quan đến việc vay vốn, hoạt
          động kinh doanh và tình hình tài chính của Bên B trước, trong và sau
          khi cho vay. <br />b) Được quyền đơn phương (không cần phải có ý kiến
          của Bên B) phong tỏa, trích hoặc xử lý các khoản tiền gửi, tài sản giữ
          hộ và giấy tờ có giá của Bên B tại Bên A hoặc bất kỳ tổ chức tín dụng
          nào để thu hồi CKPT nếu như xảy ra một hoặc các trường hợp sau đây:
          <br />i. Ngay khi đến hạn trả CKPT mà Bên B chưa trả đầy đủ. <br />ii.
          Trước khi đến hạn trả CKPT nhưng Bên A đánh giá Bên B không có khả
          năng trả CKPT khi đến hạn. Bên A không cần phải cung cấp cho Bên B cơ
          sở hay bằng chứng để chứng minh cho việc đánh giá đó. <br />iii. Ngay
          khi Bên A có thông báo thu hồi trước hạn CKPT theo quy định tại Khoản
          2 Điều 9 HĐTD này. <br />c) Chuyển nhượng hoặc ủy thác thực hiện một
          phần hoặc toàn bộ các quyền và nghĩa vụ theo HĐTD này và/hoặc (các)
          HĐBĐ cho bên thứ ba (một bên hoặc nhiều bên) mà không cần có sự chấp
          thuận của Bên B. <br />d) Chấm dứt hoặc tạm ngưng việc giải ngân cho
          Bên B theo chính sách tín dụng của Bên A trong từng thời kỳ mà không
          cần giải thích lý do với Bên B. <br />e) Bên A được quyền sử dụng tất
          cả các thông tin do Bên B cung cấp cho mục đích hoạt động cấp tín dụng
          theo HĐTD có liên quan bao gồm cả việc sử dụng thông tin để liên hệ
          các cơ quan nhà nước có thẩm quyền để xác nhận, tìm hiểu sự thật có
          liên quan đến thông tin do Bên B cung cấp. <br />f) Bên A được toàn
          quyền cung cấp thông tin của Bên B theo yêu cầu của cơ quan nhà nước
          có thẩm quyền mà pháp luật quy định Bên A có trách nhiệm cung cấp.

          <br />g) Trường hợp Bên B vi phạm nghĩa vụ trả CKPT, Bên A được quyền
          cung cấp hồ sơ hoặc công khai thông tin về việc Bên B vi phạm cho các
          cơ quan Nhà nước và các tổ chức đoàn thể, chính trị, xã hội tại địa
          phương nơi Bên B cư trú, tạm trú; cho các phương tiện thông tin đại
          chúng; hoặc cho bất kỳ tổ chức, cá nhân nào mà Bên A nhận định là có
          quan hệ hoặc liên quan với Bên B. Mọi thiệt hại phát sinh (nếu có) do
          Bên A cung cấp hồ sơ hoặc công khai thông tin do Bên B tự gánh chịu và
          không được quyền khiếu nại hay yêu cầu bồi thường. Trường hợp Bên B có
          hoặc có khả năng có các khoản phải thu từ bất kỳ tổ chức, cá nhân nào
          thì Bên A được quyền yêu cầu tổ chức, cá nhân đó chuyển các khoản phải
          thu đó về tài khoản của Bên B tại Bên A để Bên A thu hồi CKPT.
          <br />h) Khởi kiện theo quy định của pháp luật khi Bên B vi phạm HĐTD
          này hoặc (các) HĐBĐ (nếu có). <br />i) Trường hợp Bên B có bất kỳ sự
          thay đổi nào quy định tại điểm d Khoản 2 Điều 12 HĐTD này mà không
          thông báo cho Bên A thì Bên A được quyền sử dụng các thông tin cuối
          cùng mà Bên B cung cấp để làm cơ sở khởi kiện Bên B trong trường hợp
          Bên B vi phạm các thoả thuận tại HĐTD này và (các) HĐBĐ (nếu có). Bên
          B cam kết không khiếu nại việc Tòa án xét xử theo địa chỉ cuối cùng do
          Bên B cung cấp ngay cả trong trường hợp có ảnh hưởng đến quyền lợi của
          Bên B. <br />j) Các quyền khác theo quy định của HĐTD này và quy định
          của pháp luật. <br />2. Nghĩa vụ của Bên A <br />a) Thực hiện đúng các
          thỏa thuận trong HĐTD này và (các) HĐBĐ (nếu có). <br />b) Lưu trữ hồ
          sơ tín dụng theo quy định của pháp luật. <br />Điều 12. Quyền và nghĩa
          vụ của Bên B. <br />1.Quyền của Bên B a) Từ chối các yêu cầu của Bên A
          không đúng với thỏa thuận trong HĐTD này hoặc (các) HĐBĐ (nếu có).
          <br />c) Khởi kiện theo quy định của pháp luật khi Bên A vi phạm HĐTD
          này hoặc (các) HĐBĐ (nếu có). <br />2. Nghĩa vụ của Bên B <br />a) Trả
          cho Bên A CKPT đầy đủ và đúng hạn. <br />b) Tạo điều kiện thuận lợi để
          Bên A kiểm tra, giám sát và cung cấp theo yêu cầu của Bên A các thông
          tin và hồ sơ liên quan đến việc vay vốn, hoạt động kinh doanh và tình
          hình tài chính của Bên B; chịu trách nhiệm về tính chính xác, trung
          thực của các thông tin và hồ sơ đã cung cấp. <br />c) Sử dụng vốn vay
          đúng mục đích và không sử dụng vốn vay vào mục đích trái pháp luật.
          <br />d) Thông báo ngay cho Bên A bằng văn bản những trường hợp thay
          đổi hoặc chuẩn bị thay đổi địa chỉ, nội dung giấy chứng nhận đăng ký
          doanh nghiệp (nếu Bên B là tổ chức); thay đổi hoặc chuẩn bị thay đổi
          nơi cư trú, hộ khẩu thường trú, nội dung của giấy chứng minh nhân
          dân/Căn cước công dân/Hộ chiếu (nếu Bên B là cá nhân). <br />e) Trong
          trường hợp Bên A khởi kiện Bên B vi phạm HĐTD này hoặc (các) HĐBĐ thì
          Bên B cam kết chịu toàn bộ án phí, chi phí Bên A thuê luật sư, chi phí
          nhân viên của Bên A tham gia quá trình khởi kiện và toàn bộ các chi
          phí khác phát sinh trong quá trình khởi kiện. Các chi phí này do Bên A
          thông báo cho Bên B ngay khi hoặc sau khi phát sinh, Bên B cam kết
          chấp nhận các chi phí do Bên A thông báo. <br />f) Trường hợp sau khi
          định giá lại mà giá trị (các) Tài sản bảo đảm thấp hơn giá trị đã thỏa
          thuận tại (các) HĐBĐ và không còn đủ khả năng bảo đảm cho nghĩa vụ thì
          Bên B phải bổ sung tài sản bảo đảm hoặc phải trả trước hạn một phần
          hoặc toàn bộ CKPT trong vòng 30 ngày kể từ ngày nhận được thông báo
          của Bên A. Hết thời hạn này mà Bên B chưa bổ sung tài sản bảo đảm hoặc
          chưa trả trước hạn một phần hoặc toàn bộ CKPT thì Bên A được quyền xử
          lý (các) Tài sản bảo đảm để thu hồi CKPT, kể cả khi chưa đến hạn trả
          CKPT. <br />Điều 13. Phạt vi phạm và bồi thường thiệt hại <br />1.
          Ngoại trừ các trường hợp vi phạm khác đã có mức phạt vi phạm cụ thể
          theo quy định tại HĐTD này, Bên B phải có nghĩa vụ bồi thường toàn bộ
          thiệt hại cho Bên A và chịu phạt vi phạm theo mức 8% giá trị phần
          nghĩa vụ bị vi phạm hoặc mức phạt tối đa khác theo quy định của Pháp
          luật trong từng thời kỳ. Khi phát sinh vi phạm, Bên A sẽ thông báo
          bằng văn bản về số tiền phạt/bồi thường và thời hạn thanh toán gửi đến
          Bên B, văn bản thông báo có giá trị ràng buộc nghĩa vụ đối với Bên B.

          <br />2. Nếu Bên B vi phạm quy định tại HĐTD và Bên A phải áp dụng các
          biện pháp xử lý thu hồi nợ (bao gồm cả biện pháp khởi kiện), Bên B cam
          kết sẽ bồi thường/bồi hoàn cho Bên A toàn bộ các chi phí hợp lý, trong
          phạm vi Pháp luật cho phép, bao gồm chi phí luật sư, tố tụng, chi phí
          đi lại, thông tin liên lạc, sao, chụp, công chứng, dịch thuật tài
          liệu, chuẩn bị tài liệu tố tụng, phí thi hành án theo đúng thông báo
          và chứng từ do Bên A cung cấp. <br />Điều 14. Điều khoản thi hành.
          <br />1. Những điều khoản không quy định trong HĐTD này sẽ được áp
          dụng theo các quy định của pháp luật có liên quan.Việc sửa đổi, bổ
          sung các điều khoản của HĐTD này phải được lập thành văn bản và được
          Các bên thống nhất ký kết bởi người có thẩm quyền mới có giá trị. Các
          văn bản sửa đổi, bổ sung, KUNN là một phần không tách rời của HĐTD
          này, bất kỳ văn bản nào dẫn chiếu đến HĐTD này cũng bao gồm các văn
          bản sửa đổ bổ sung đó. <br />2. (Các) HĐBĐ được nêu trong HĐTD này
          cũng bao gồm các văn bản sửa đổi, bổ sung hoặc thay thế của (các) HĐBĐ
          đó (nếu có). <br />3. Trường hợp nội dung của bất kỳ Điều, khoản nào
          thoả thuận trong HĐTD trái với quy định pháp luật hoặc có các quy định
          khác với thỏa thuận trong HĐTD này và buộc Các bên phải thực hiện thì
          Các bên phải tự động thực hiện mà không cần phải ký văn bản sửa đổi,
          bổ sung HĐTD. <br />4. HĐTD này được điều chỉnh bởi pháp luật nước
          CHXHCN Việt Nam. Mọi tranh chấp phát sinh trong quá trình thực hiện
          HĐTD này được giải quyết trên cơ sở thương lượng, bình đẳng giữa Các
          bên. Trường hợp không tự thương lượng được thì Các bên có quyền đưa ra
          toà án có thẩm quyền giải quyết. <br />5. HĐTD này có hiệu lực kể từ
          ngày ký và chỉ hết hiệu lực đồng thời đương nhiên thanh lý khi Bên B
          trả cho Bên A đầy đủ CKPT.
        </div>
        <div style="line-height: 1.8; font-size: 13px; display: none">
          <p class="text-xs leading-6">
            Tên khách hàng: {{ this.usrdata.bankName }}
          </p>
          <p class="text-xs leading-6">
            Số tiền: {{ formatNumberWithCommas(loan.price) }}
            {{ $t("common.unit") }}
          </p>
          <p class="text-xs leading-6">
            Lãi suất: {{ lilv }} % / {{ $t("common.month") }}
          </p>
          <p class="text-xs leading-6">
            Số tiền trả hàng tháng:
            {{ formatNumberWithCommas(loan.monthlyPayment) }}
            {{ $t("common.unit") }}
          </p>
          <p class="text-xs leading-6">
            Bên A (Bên cho vay):
            <span style="font-weight: 800"
              >Ngân hàng TMCP Quốc Tế Việt Nam</span
            >
          </p>
          <p class="text-xs leading-6">
            Bên B (Bên vay) Ông / Bà :<span style="font-weight: 800"
              >Các thông tin bên B đã đăng ký tại ứng dụng. Cụ thể thông tin về
              số tiền vay, thời gian vay, lãi suất và số tiền thanh toán trả góp
              đã có tại mục ví tiền.</span
            >
          </p>
          <p class="text-xs leading-6">
            Hợp đồng nêu rõ các bên đã đặt được thỏa thuận vay sau khi thương
            lượng và trên cơ sở bình đẳng , tự nguyện và nhất trí . Tất cả các
            bên cần đọc kỹ tất cả các điều khoản trong thỏa thuận này, sau khi
            ký vào thỏa thuận này coi như các bên đã hiểu đầy đủ và đồng ý hoàn
            toàn với tất cả các điều khoản và nội dung trong thỏa thuân này.
          </p>
          <p class="text-xs leading-6">
            1.Phù hợp với các nguyên tắc bình đẳng , tự nguyện , trung thực và
            uy tín , hai bên thống nhất ký kết hợp đồng vay sau khi thương lượng
            và cùng cam kết thực hiện.
          </p>
          <p class="text-xs leading-6">
            2.Bên B cung cấp tài liệu đính kèm của hợp đồng vay và có hiệu lực
            pháp lý như hợp đồng vay này.
          </p>
          <p class="text-xs leading-6">
            3.Bên B sẽ tạo lệnh tính tiền gốc và lãi dựa trên số tiền vay từ ví
            ứng dụng do bên A cung cấp.
          </p>
          <p class="text-xs leading-6">4.Điều khoản đảm bảo.</p>
          <p class="text-xs leading-6">
            - Bên vay không được sử dụng tiền vay để thực hiện các hoạt động bất
            hợp pháp .Nếu không , bên A có quyền yêu cầu bên B hoàn trả ngay
            tiền gốc và lãi , bên B phải chịu các trách nhiêm pháp lý phát sinh
            từ đó.
          </p>
          <p class="text-xs leading-6">
            - Bên vay phải trả nợ gốc và lãi trong thời gian quy định hợp đồng.
            Đối với phần quá hạn , người cho vay có quyền thu hồi nơ trong thời
            hạn và thu ( lãi quá hạn ) % trên tổng số tiền vay trong ngày.
          </p>
          <p class="text-xs leading-6">
            - Gốc và lãi của mỗi lần trả nợ sẽ được hệ thống tự động chuyển từ
            tài khoản ngân hàng do bên B bảo lưu sang tài khoản ngân hàng của
            bên A . Bên B phải đảm bảo có đủ tiền trong tài khoản ngân hàng
            trước ngày trả nợ hàng tháng.
          </p>
          <p class="text-xs leading-6">
            5.Chịu trách nhiệm do vi pham hợp đồng
          </p>
          <p class="text-xs leading-6">
            - Nếu bên B không trả được khoản vay theo quy định trong hợp đồng.
            Bên B phải chịu các khoản bồi thường thiệt hại đã thanh lý và phí
            luật sư, phí kiện tụng, chi phí đi lại và các chi phí khác phát sinh
            do kiện tụng.
          </p>
          <p class="text-xs leading-6">
            - Khi bên A cho rẳng bên B đã hoặc có thể xảy ra tình huống ảnh
            hưởng đến khoản vay thì bên A có quyền yêu cầu bên B phải trả lại
            kịp thời trược thời hạn.
          </p>
          <p class="text-xs leading-6">
            - Người vay và người bảo lãnh không được vi phạm điều lệ hợp đồng vì
            bất kỳ lý do gì
          </p>
          <p class="text-xs leading-6">
            6.Phương thức giải quyết tranh chấp hợp đồng. <br />Tranh chấp phát
            sinh trong quá trình thực hiện hợp đồng này sẽ được giải quyết thông
            qua thương lượng thân thiện giữa các bên hoặc có thể nhờ bên thứ ba
            làm trung gian hòa giải .Nếu thương lượng hoặc hòa giải không thành
            , có thể khởi kiện ra tòa án nhân dân nơi bên A có trụ sở.
          </p>
          <p class="text-xs leading-6">
            7.Khi người vay trong quá trình xét duyệt khoản vay không thành công
            do nhiều yếu tố khác nhau như chứng minh thư sai, thẻ ngân hàng sai
            , danh bạ sai. Việc thông tin sai lệch này sẽ khiến hệ thống phát
            hiện nghi ngờ gian lận hoặc giả mạo khoản vay và bên vay phải chủ
            động hợp tác với bên A để xử lý.
          </p>
          <p class="text-xs leading-6">
            8.Nếu không hợp tác. Bên A có quyền khởi kiện ra Tòa án nhân dân và
            trình báo lên Trung tâm Báo cáo tín dụng của Ngân hàng nhà nước Việt
            Nam , hồ sơ nợ xấu sẽ được phản ánh trong báo cáo tín dụng , ảnh
            hưởng đến tín dụng sau này của người vay , vay vốn ngân hàng và hạn
            chế tiều dùng của người thân , con cái người vay ...
          </p>
        </div>
        <van-row style="text-align: center; margin: 30px 0; line-height: 2">
          <van-col :span="12">
            <p>Bên vay</p>
            <img :src="this.usrdata.signature" style="width: 90%" />
          </van-col>
          <van-col :span="12">
            <p>Bên cho vay</p>
            <img src="../../assets/imgs/contract/1.png" style="width: 90%" />
          </van-col>
        </van-row>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { formatNumberWithCommas } from "@/utils/validate";
import { Toast } from "vant";
import Footer from "@/components/footer/index.vue";
import Header from "@/components/header/index.vue";
export default {
  name: "ContractView",
  components: { Footer, Header },
  data() {
    return {
      usrdata: {},
      loan: {},
      lilv: 0,
      sign: null,
    };
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ name: "login" });
    } else {
      this.getSetting();
      this.getInfo();
      this.getlst();
    }
  },
  methods: {
    formatNumberWithCommas(val) {
      return formatNumberWithCommas(val);
    },
    getSetting() {
      this.$http({
        method: "get",
        url: "getloansetting",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.lilv = parseFloat(res.data.interest);
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    getlst() {
      this.$http({
        method: "get",
        url: "getloan",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.loan = res.data[0];
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    getInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.usrdata = res.data;
          }
        } else if (res.code === 401) {
          Toast(res.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.txt-box {
  width: 96%;
  margin: 10px auto;
  padding: 10px;
}
</style>
